import _ from 'lodash';
import store from "services/redux/store";
import { dataConstants } from "services/redux/data/constants";

export default class HelperAvailability {
	
	static AVAILABLE_FOR_EVERYONE = 'everyone';
	static AVAILABLE_FOR_RESTRICTED = 'restricted';
	static AVAILABLE_FOR_RESTRICTED_EMPLOYEES = 'restricted_employees';
	
	static log = ( value ) => {
		console.prefix( 'HelperAvailability', value );
	}
	
	/**
	 *
	 * @param type (building, floor, room, table)
	 * @param object
	 * @returns {boolean}
	 */
	static isAvailable = ( type, object ) => {
		const availableFor = _.get( object, 'available_for', 'everyone' );
		
		// When available for everyone we can just return true
		if( availableFor === this.AVAILABLE_FOR_EVERYONE ) {
			return true;
		}
		
		const state = store.getState();
		
		// Get the current employee
		const _employee = state.data[ dataConstants.EMPLOYEE ];
		
		switch( availableFor ) {
			case this.AVAILABLE_FOR_RESTRICTED:
				// Get all the rights for the employees team
				const employeeTeamBuildingRights = _.get( _employee, [ 'team', 'building_rights' ] );
				
				let teamHasRights = false;
				_.forEach( employeeTeamBuildingRights, ( right ) => {
					if ( _.isEqual( _.get( right, [ type, 'guid' ], null ), object.guid ) ) {
						teamHasRights = true;
					}
				});
				
				return teamHasRights;
				
			case this.AVAILABLE_FOR_RESTRICTED_EMPLOYEES:
				// Get all the rights for the employees team
				const employeeBuildingRights = _.get( _employee, [ 'building_rights' ] );
				
				let hasRights = false;
				_.forEach( employeeBuildingRights, ( right ) => {
					if ( _.isEqual( _.get( right, [ type, 'guid' ], null ), object.guid ) ) {
						hasRights = true;
					}
				});
				
				return hasRights;
		}


		return false;
	}
}
